import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {onReject} from '../handler'
import type {TopcupState} from './entities'
import type {EntryType} from 'services/yandexSDK'
import {getEntriesThunk} from './thunk'

const initialState: TopcupState = {
  entries: []
}

const topcup = createSlice({
  name: 'topcup',
  initialState: initialState,
  reducers: {
    setEntries: (state, action: PayloadAction<EntryType[]>) => {
      state = {
        entries: action.payload,
      }
      return state
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getEntriesThunk.fulfilled, (state) => {
      return state
    })
    builder.addCase(getEntriesThunk.rejected, (state, action) => {
      onReject(action.payload)
    })
  },
})

export const {
  setEntries,
} = topcup.actions

export default topcup.reducer
